import { BaseRequest } from './BaseRequest';

export class SubscriptionRequest extends BaseRequest {
    OrganizationId: string | null;
    PaymentAccount: string | null;
    PlanId: string | null;
    Plan: string | null;
}